function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "E05A363F-6397-47B7-ACE9-44A18B5EAD33");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-620.000000, -6272.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Chevron_Left",
  transform: "translate(620.000000, 6272.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.4643757,6.23643894 L9.48903805,6.26110129 L9.48903805,6.26110129 L13.771,10.723 L13.7763993,10.718949 L14.3368095,11.3028716 C14.7081651,11.6898077 14.7081651,12.3007992 14.3368095,12.6877353 L14.3368095,12.6877353 L9.48903805,17.7388987 L9.48903805,17.7388987 L9.4643757,17.7635611 C9.12611224,18.0882039 8.58872052,18.0771622 8.2640777,17.7388987 C7.9218192,17.3822805 7.9218192,16.8191624 8.2640777,16.4625442 L8.2640777,16.4625442 L12.546,11.999 L8.2640777,7.53745579 C7.9218192,7.18083757 7.9218192,6.61771951 8.2640777,6.26110129 C8.58872052,5.92283783 9.12611224,5.91179612 9.4643757,6.23643894 Z",
  id: "Combined-Shape",
  transform: "translate(11.326479, 12.000000) rotate(180.000000) translate(-11.326479, -12.000000) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}))));

var SvgIconChevronLeft = function SvgIconChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Chevron_Left.42507b3b.svg";
export { ForwardRef as ReactComponent };